<template lang="pug">
  TimeRange(:reservation="reservation", :availability="availability", @selection="handleExtend")
</template>

<script>
  import TimeRange from './TimeRange'
  import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../maggieHelper'

  export default {
    name: 'TimeRangeWrapper',
    components: {TimeRange},
    methods: {
      handleExtend(timestamp) {
        KeplerBackofficeSdk.reservations.select(this.reservation.number).extend(this.$convertTimestamp(timestamp), (response) => {
          MaggieHelper.notification('extend-esit', 'reservation extended')
          MaggieHelper.closeTopPanel()
        }, (e) => {
          MaggieHelper.notification(e.result_code, e.messages, 'alert')
          MaggieHelper.closeTopPanel()
        })

      }
    },
    props: ['reservation', 'availability']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TimeRangeWrapper.vue?96dd5246